import { type FC, type CSSProperties } from 'react';
import { getCurrentVersion } from '@/config/version';

interface VersionDisplayProps {
  /** Theme variant for different page backgrounds */
  variant?: 'light' | 'dark' | 'transparent';
  /** Custom positioning styles if needed */
  style?: CSSProperties;
}

const VersionDisplay: FC<VersionDisplayProps> = ({
  variant = 'transparent',
  style = {}
}) => {
  const version = getCurrentVersion();

  const getVariantStyles = () => {
    const baseStyles: CSSProperties = {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '8px 12px',
      borderRadius: '20px',
      fontSize: '0.85rem',
      fontWeight: '500',
      zIndex: 1000,
      fontFamily: 'monospace',
      userSelect: 'none',
      pointerEvents: 'none',
      transition: 'all 0.3s ease',
      ...style
    };

    switch (variant) {
      case 'light':
        return {
          ...baseStyles,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          color: '#333',
          border: '1px solid rgba(0, 0, 0, 0.2)',
        };
      case 'dark':
        return {
          ...baseStyles,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          color: '#fff',
          border: '1px solid rgba(255, 255, 255, 0.2)',
        };
      case 'transparent':
      default:
        return {
          ...baseStyles,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          color: '#fff',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(10px)',
        };
    }
  };

  return (
    <div style={getVariantStyles()}>
      v{version}
    </div>
  );
};

export default VersionDisplay;